import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
}

export default function Button({ children, variant = 'primary', className = '', ...props }: ButtonProps) {
  return (
    <button
      {...props}
      className={`px-4 py-2 rounded-md font-medium transition-colors
        ${variant === 'primary' 
          ? 'bg-orange-500 text-white hover:bg-orange-600' 
          : 'bg-gray-200 text-gray-800 hover:bg-gray-300'} 
        ${className}`}
    >
      {children}
    </button>
  );
}
